import { render, staticRenderFns } from "./addPromocode.vue?vue&type=template&id=83ae899e&"
import script from "./addPromocode.vue?vue&type=script&lang=js&"
export * from "./addPromocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports